  <div class="corps">
   
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-10 col-lg-8 mx-auto">
                <div class="card border-0 shadow rounded-3 my-5">
                    <div class="card-body p-4 p-sm-5">
                        <h5 class="card-title text-center mb-5 fw-light fs-5">{{ 'INITPASSWORD.TITLE' | translate }}</h5>
                        <p class="text-muted text-center">{{ 'INITPASSWORD.DESCRIPTION' | translate }}</p>

                        <!-- Message d'erreur -->
                        <div *ngIf="etatconnexion" class="alert alert-danger text-center mb-4" role="alert">
                            {{ message }}
                        </div>

                        <form [formGroup]="InitpassForm" (ngSubmit)="onSubmit()">
                            <!-- Email field -->
                            <div class="input-group mb-4">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <nb-icon icon="email-outline" [options]="{ animation: { type: 'zoom' } }"></nb-icon>
                                        <span class="text-danger ms-1">*</span>
                                    </span>
                                </div>
                                <input type="email" 
                                       formControlName="email" 
                                       class="form-control" 
                                       [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                                       [placeholder]="'INITPASSWORD.EMAIL_PLACEHOLDER' | translate"
                                       autocomplete="email"
                                       required>
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <span *ngIf="f.email.errors.required">{{ 'INITPASSWORD.REQUIRED_FIELD' | translate }}</span>
                                    <span *ngIf="f.email.errors.email">{{ 'INITPASSWORD.INVALID_EMAIL' | translate }}</span>
                                </div>
                            </div>

                            <hr class="my-4">

                            <!-- Buttons row -->
                            <div class="row g-3">
                                <div class="col-12 col-sm-6">
                                    <button type="submit" 
                                            [disabled]="loading" 
                                            class="btn btn-primary w-100">
                                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
                                        {{ 'INITPASSWORD.SUBMIT' | translate }}
                                    </button>
                                </div>
                                <div class="col-12 col-sm-6 text-end">
                                    <button type="button" 
                                            class="btn btn-link w-100" 
                                            routerLink="/login">
                                        {{ 'INITPASSWORD.BACK_TO_LOGIN' | translate }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  